import AdventureMarkPage from "./AdventureMarkPage";

export default AdventureMarkPage;
